export interface IShownProperties {
    birthdate: boolean,
    mobile: boolean,
    phone: boolean,
    email: boolean,
    communikePassword: boolean,
    insuranceNumber: boolean,
    address: boolean,
    contact: boolean,
    workplace: boolean,
    groups: boolean,
    targetGroup: boolean,
    workgroup: boolean,

    primaryContact: boolean,
    keyWorker: boolean,
    personRestriction: boolean,
    serviceForm: boolean,
    dependence: boolean,
    carePayment: boolean,
    folderPersonStay: boolean,
    familyWithTriplets: boolean,
    resistanceFighter: boolean,
    rehabilitationPerson: boolean,
    personFromLaborCamp: boolean,
    spouseOfResistanceFighterOver70: boolean,
    spouseOfRehabilitationPersonOver70: boolean,
    spouseOfPersonFromLaborCampOver70: boolean,
    livingInSecialPurposeApartment: boolean,
    overindebtedClient: boolean,
    clientHasPermanentResidenceInService: boolean,
    clientHadResidenceAbroad: boolean,
    residenceBeforeStartOfServiceProvision: boolean,
    permanentlyBedridden: boolean,
    clientIsMobileWithHelp: boolean,
    healthCareIsProvided: boolean,
}

export const shownPropertiesDefaultValues: IShownProperties = {
    address: true,
    mobile: true,
    phone: true,
    email: true,
    communikePassword: true,
    birthdate: true,
    contact: true,
    insuranceNumber: true,
    workplace: true,
    groups: true,
    targetGroup: true,
    workgroup: true,

    primaryContact: true,
    keyWorker: true,
    personRestriction: true,
    serviceForm: true,
    dependence: true,
    carePayment: true,
    folderPersonStay: true,
    familyWithTriplets: true,
    resistanceFighter: true,
    rehabilitationPerson: true,
    personFromLaborCamp: true,
    spouseOfResistanceFighterOver70: true,
    spouseOfRehabilitationPersonOver70: true,
    spouseOfPersonFromLaborCampOver70: true,
    livingInSecialPurposeApartment: true,
    overindebtedClient: true,
    clientHasPermanentResidenceInService: true,
    clientHadResidenceAbroad: true,
    residenceBeforeStartOfServiceProvision: true,
    permanentlyBedridden: true,
    clientIsMobileWithHelp: true,
    healthCareIsProvided: true,
};
